import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { SubjectType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import { BLOCK_TYPES } from '@aytm/app/insights/dashboard/lib/config'
import { ItemListModel, MilestoneListModel } from '@aytm/app/insights/dashboard/models/types.ClientModel'

export type TimelineUISelectorParams = {
  isDataUpdating: boolean
  isTimelineShown: boolean
  initialZoom: number
  initialOffset: number
}

export type TimelineHooksSelectorParams = {
  isSharedView: boolean
  isTracker: boolean
  currentSplit: string | null
  subjects: Record<string, SubjectType>
  blockMilestones: MilestoneListModel
  blockItems: ItemListModel | null
}

export const timelineUISelector = (state: InsightsDashboardPoolState): TimelineUISelectorParams => {
  const isDataUpdating = state.currentData?.dataUpdating || false
  const block = getCurrentBlock(state)
  const isTimelineShown = block?.get<boolean>('showTimeline') || false
  const initialZoom = block?.get<number>('timelineZoom') || 1
  const initialOffset = block?.get<number>('timelineOffset') || 0
  return {
    isDataUpdating,
    isTimelineShown,
    initialZoom,
    initialOffset
  }
}

export const timelineUIValidator = (prev: TimelineUISelectorParams, next: TimelineUISelectorParams) =>
  !prev && !next
    ? false
    : prev.isDataUpdating !== next.isDataUpdating ||
      prev.isTimelineShown !== next.isTimelineShown ||
      prev.initialZoom !== next.initialZoom ||
      prev.initialOffset !== next.initialOffset

export const timelineHooksSelector = (state: InsightsDashboardPoolState): TimelineHooksSelectorParams => {
  const block = getCurrentBlock(state)
  return {
    isSharedView: state.isSharedView,
    isTracker: block?.type === BLOCK_TYPES.TRACKING_VALUES,
    currentSplit: block?.get<string>('currentSplit') || null,
    subjects: state.currentData?.subjects || {},
    blockMilestones: block?.get<MilestoneListModel>('milestones') || null,
    blockItems: block?.get<ItemListModel>('items') || null
  }
}

export const timelineHooksValidator = (prev: TimelineHooksSelectorParams, next: TimelineHooksSelectorParams) =>
  !prev && !next
    ? false
    : prev.isSharedView !== next.isSharedView ||
      prev.isTracker !== next.isTracker ||
      prev.currentSplit !== next.currentSplit ||
      prev.subjects !== next.subjects ||
      prev.blockMilestones !== next.blockMilestones ||
      prev.blockItems !== next.blockItems
